module.exports = __webpack_public_path__ + "img/logoSignln.76f4dcbb.png";